<template>
  <div
    ref="menu"
    v-if="! $store.getters['settingsModule/elementSidebar']"
    :class="positionClasses"
    class="wf--ml-48 wf-absolute wf-bg-white wf-rounded-lg wf-overflow-hidden wf-border-4 wf-border-white wf-shadow-md wf-w-56 wf-z-50"
  >
    <ul>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="content"
        title="Content"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in contentProperties"
            :key="property.key"
            :is="property.component"
            :text="property.text"
            :property="property.property"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        v-if="parent.showLabels"
        @updateOpen="updateOpen"
        trigger="labelStyles"
        title="Labels Style"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in labelStyleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :styles="property.styles"
            :text="property.text"
            :is="property.component"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="inputsStyles"
        title="Inputs Style"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in inputStyleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :styles="property.styles"
            :text="property.text"
            :is="property.component"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="buttonStyles"
        title="Button Style"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in buttonStyleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :styles="property.styles"
            :text="property.text"
            :is="property.component"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="advanced"
        title="Advanced"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in advancedProperties"
            :key="property.key"
            :is="property.component"
            :element="element"
          ></component>
        </template>
      </EditorElementMenuList>
    </ul>
  </div>
</template>

<script>
  import ElementMenu from '../../contracts/ElementMenu'
  export default ElementMenu.extend({
    data() {
      return {
        open: 'content',
      }
    },
    computed: {
      contentProperties() {
        return this.parent.properties.content
      },
      buttonStyleProperties() {
        return this.parent.properties.buttonStyles
      },
      labelStyleProperties() {
        return this.parent.properties.labelStyles
      },
      inputStyleProperties() {
        return this.parent.properties.inputsStyles
      },
      advancedProperties() {
        return this.parent.properties.advanced
      },
    }
  })
</script>
